import { render, staticRenderFns } from "./BadgeList.vue?vue&type=template&id=e56841e0&"
import script from "./BadgeList.vue?vue&type=script&lang=js&"
export * from "./BadgeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports